const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
})

export default styles
